export default __webpack_public_path__ + "static/media/h_logo_animated_4.1e8b1076.svg";